export const GET_STATS_REQUEST = 'GET_STATS_REQUEST';
export const GET_STATS_SUCCESS = 'GET_STATS_SUCCESS';
export const GET_STATS_FAILURE = 'GET_STATS_FAILURE';

export const RENEW_CACHE_REQUEST = 'RENEW_CACHE_REQUEST';
export const RENEW_CACHE_SUCCESS = 'RENEW_CACHE_SUCCESS';
export const RENEW_CACHE_FAILURE = 'RENEW_CACHE_FAILURE';
